module.exports = __webpack_public_path__ + "img/ic-log-face.c2a254ef.svg";